import { useRef, useState } from "react";
import { ChevronsLeftRight } from "lucide-react";

export const CompareSlider = ({ imageAntes, imageDepois, testid }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  const update = (clientX) => {
    const r = ref.current.getBoundingClientRect();
    setPos(Math.min(96, Math.max(4, ((clientX - r.left) / r.width) * 100)));
  };

  const onDown = (e) => {
    update(e.clientX);
    const move = (ev) => update(ev.clientX);
    const up = () => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  };

  return (
    <div
      ref={ref}
      data-testid={testid}
      onPointerDown={onDown}
      className="relative aspect-[16/10] overflow-hidden rounded-3xl border border-gold/30 select-none cursor-ew-resize touch-none bg-ink"
    >
      <img
        src={imageDepois}
        alt="Depois do serviço Gold"
        draggable={false}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <img
        src={imageAntes}
        alt="Antes do serviço Gold"
        draggable={false}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover"
        style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}
      />
      <span className="absolute top-3 left-3 rounded-full bg-black/70 backdrop-blur px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-200">
        Antes
      </span>
      <span className="absolute top-3 right-3 rounded-full bg-gold px-3 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-ink">
        Depois
      </span>
      <div
        className="absolute top-0 bottom-0 w-0.5 bg-gold shadow-[0_0_20px_rgba(212,175,55,0.8)]"
        style={{ left: `${pos}%` }}
      >
        <span className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 flex h-10 w-10 items-center justify-center rounded-full bg-gold text-ink shadow-lg">
          <ChevronsLeftRight className="h-5 w-5" />
        </span>
      </div>
    </div>
  );
};
